import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader';

import { aiVideoList } from './AIVideoList';
import "./styles/AIVideoDialogStyles.css"
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import DialogHeaderWithClose from '../../components/basic/DialogHeaderWithClose';
import { DialogInput } from '../../components/advanced';

class AIVideoDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openVideo: false,
      currentVideoUrl: ""
    }
  }

  convertToEmbedUrl = (url) => {
    let embedUrl = url;
    // standard link
    if (url.includes('watch?v=')) {
      embedUrl = url.replace('watch?v=', 'embed/');
    }
    // shortened link
    else if (url.includes('youtu.be/')) {
      embedUrl = url.replace('youtu.be/', 'www.youtube.com/embed/');
    }

    // Append autoplay parameter
    embedUrl += (embedUrl.includes('?') ? '&' : '?') + 'autoplay=1';

    return embedUrl;
  }

  stripTrailingNumbers = (url) => {
    const hasUUID = /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(\/|$)/i.test(url);
    const re = /(\/[a-zA-Z]+(\/[a-zA-Z]+)*\/)(\d+|[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/;

    if (hasUUID) {
      url = url.replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(\/|$)/i, '/hasNumber');
    }
    if (re.test(url)) {
      url = url.replace(re, "$1hasNumber");
    }

    const reDate = /(\/[0-9]{2}-[0-9]{2}-[0-9]{4})$/;
    if (reDate.test(url)) {
      url = url.replace(reDate, "");
    }

    return url;
  }

  closeCurrentVideo = () => {
    this.setState({ openVideo: false, currentVideoUrl: "" })
  }

  handleOpenVideo = (videoUrl) => {
    const embedUrl = this.convertToEmbedUrl(videoUrl);
    this.setState({ openVideo: true, currentVideoUrl: embedUrl });
  }

  getVideoInfo = (aiVideoList, path) => {
    const page = aiVideoList.find(item => item.path === path);
    if (page) {
      let filteredVideos = page.aiVideos;
      if (this.props.isMedical) {
        filteredVideos = page.aiVideos.filter(video => video.type !== LOOKUP.AiVideoType.LicensedRetail);
      } else {
        filteredVideos = page.aiVideos.filter(video => video.type !== LOOKUP.AiVideoType.FirstNation);
      }
      return { aiVideos: filteredVideos, pageName: page.pageName };
    }

    return { aiVideos: [], pageName: "" };
  };

  render() {
    let currentPath = window.location.pathname ? this.stripTrailingNumbers(window.location.pathname) : "";
    const { aiVideos: videos, pageName } = this.getVideoInfo(aiVideoList, currentPath);
    return (
      <div>
          <DialogInput
              title={<DialogHeaderWithClose text={`Support Videos: ${pageName}`} classicClass="posDialogClassic" handleClose={() => { this.props.onClose();
                  this.closeCurrentVideo()}} />}
              className="checkIn_list"
              open={this.props.open}
              autoScrollBodyContent={true}

          >

          <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center'
              }}
            >
              <Button
                key={1}
                name="buttonRefundDialogCancel"
                type="Button"

                className="corner_X"
                primary={false}
                onTouchTap={() => { this.props.onClose(), this.closeCurrentVideo() }} />


              {this.state.currentVideoUrl ? (
                <iframe
                   width="1200"
                  height="800"
                  src={this.state.currentVideoUrl}
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  style={{
                    width: '100%',
                    height: '70vh',
                    marginTop: '40px',
                  }}
                ></iframe>
              ) : (
                videos.map((video, i) => (
                  <div
                    key={i}
                    style={{
                      minWidth: '360px',
                      height: '200px',
                      margin: '10px',
                      position: 'relative',
                      borderRadius: '10px',
                      overflow: 'hidden'
                    }}
                    onClick={() => this.handleOpenVideo(video.videoUrl)}
                  >
                    <img
                      src={video.thumbnailUrl}
                      alt={video.title}
                      style={{
                        minWidth: '360px',
                        height: '200px',
                        borderRadius: '10px'
                      }}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        color: 'white',
                        padding: 10,
                        boxSizing: 'border-box',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap'
                      }}>{video.title}
                    </div>
                  </div>
                ))
              )}

            </div>
            </div>

          {this.state.currentVideoUrl &&
                <Button
                  name="AiVideoBackButon"
                  type="RaisedButton"
                  label={"Back"}
                  style={{ position: "absolute", bottom: "12px" }}
                  onTouchTap={this.closeCurrentVideo}
                />}
            </DialogInput>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMedical: state.common.applicationSettings.isMedical
  };
}

export default connect(mapStateToProps, null)(AIVideoDialog);
